import { render, staticRenderFns } from "./RelatorioFormularioRespostaListRoute.vue?vue&type=template&id=3b548f72"
import script from "./RelatorioFormularioRespostaListRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioFormularioRespostaListRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports